'use strict';

var _mongoose = require('mongoose');

var _mongoose2 = _interopRequireDefault(_mongoose);

var _enums = require('../enums');

var _enums2 = _interopRequireDefault(_enums);

var _isVisible = require('./isVisible');

var _isVisible2 = _interopRequireDefault(_isVisible);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var schema = new _mongoose2.default.Schema({
  type: {
    type: String,
    enum: (0, _lodash.values)(_enums2.default.cancellationPolicy.types)
  },
  availableBefore: {
    type: Number
  },
  refund: {
    type: { type: String, enum: (0, _lodash.keys)(_enums2.default.cancellationPolicy.refundQuantities) },
    amount: {
      type: Number
    }
  },
  penalty: {
    type: {
      type: String,
      enum: (0, _lodash.keys)(_enums2.default.cancellationPolicy.refundQuantities)
    },
    fee: {
      type: Number
    }
  }
});

// lodash


schema.path('refund.amount').validate(function (amount) {
  if (this.type === 'Partial Refund') {
    return !!amount;
  }
  return true;
}, 'Refund amount is required for partial refunds');

schema.path('penalty.fee').validate(function (fee) {
  if (this.type === 'Penalty') {
    return !!fee;
  }
  return true;
}, 'Penalty fee is required');

module.exports = schema;